module.exports = __webpack_public_path__ + "assets/img/diners-club.948877be.svg";